import { j as i } from "./jsx-runtime-DywqP_6a.js";
import { Slot as a } from "@radix-ui/react-slot";
import { c as u } from "./index-DI5SPFK9.js";
import * as c from "react";
import { c as x } from "./cn-dYga0KKN.js";
const f = u(
  "not-prose inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        "ghost-destructive": "text-destructive hover:bg-destructive hover:text-destructive-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        expand: "flex gap-1.5 border bg-transparent rounded-xl text-muted-foreground hover:text-foreground"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        xl: "h-14 rounded-lg px-10 text-lg",
        icon: "size-9",
        "icon-xs": "size-7"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), g = c.forwardRef(
  ({ className: e, variant: t, size: r, asChild: o = !1, ...n }, s) => {
    const d = o ? a : "button";
    return /* @__PURE__ */ i.jsx(
      d,
      {
        className: x(f({ variant: t, size: r, className: e })),
        ref: s,
        ...n
      }
    );
  }
);
g.displayName = "Button";
export {
  g as B
};
//# sourceMappingURL=Button-DTDRi4CT.js.map
